import React, { Component } from 'react'
// import { Route, Switch } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Iframe from 'react-iframe'
import Security from '../../commons/security/Security.js'
import { Redirect } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

class Avl extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            redirectTo: null,
            avlService: ConfigBusiness.get('avl_service.service'),
        }
    }

    componentWillMount() {
        if (!Security.hasPermission('AVL_ACCEDER')) {
            this.setState({
                redirectTo: '/error'
            });
        }
    }

    renderAvl() {
        if (this.state.avlService == "traccar" && ConfigBusiness.get('frontend.urlAvl')) {
            let persona = JSON.parse(localStorage.getItem('persona'));
            let hash = persona.usuario.id + ConfigBusiness.get('frontend.traccarHash');

            return (
                <Iframe url={ConfigBusiness.get('frontend.urlAvl') + hash}
                    width="100%"
                    height="800px"
                    id="myId"
                    className="embed-responsive-item"
                    display="initial"
                    position="relative"
                    allowFullScreen/>
            );
        }
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center px-2" style={{ minHeight: "500px" }}>
                <i className="la la-map-marker text-muted" style={{ fontSize: "4rem" }}></i>
                <h3 className="mt-1"><FormattedMessage id="avl.no_disponible.title" defaultMessage="El Mapa no está disponible por el momento" /></h3>
                <p className="text-muted" style={{ maxWidth: "520px" }}><FormattedMessage id="avl.no_disponible.message" defaultMessage="Estamos trabajando para ofrecerte una mejor experiencia. Mientras tanto, el resto de los módulos de VecFleet sigue funcionando con normalidad." /></p>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.state.redirectTo ? <Redirect push to={this.state.redirectTo} />:this.renderAvl() }
            </React.Fragment>
        )
    }
}

export default Avl;
